module.exports = "/packs/media/images/module-social-small-f65e68ceaf8e42b1804a128f34f48628.png";